'use client'
import { createContext, PropsWithChildren, FC, useContext } from 'react'

export const AutoWalletConnectContext = createContext({
  forceRerender: () => {},
})

export const AutoWalletConnectProvider: FC<PropsWithChildren> = ({ children }) => {
  const forceRerender = () => {}

  return (
    <AutoWalletConnectContext.Provider
      value={{
        forceRerender,
      }}
    >
      {children}
    </AutoWalletConnectContext.Provider>
  )
}

export const useAutoWalletConnect = () => {
  const context = useContext(AutoWalletConnectContext)

  if (!context) {
    throw new Error('useAutoWalletConnect must be used within AutoWalletConnectProvider')
  }

  return context
}
